export default function replacePageHtml (htmlString) {
    document.open();
    document.write(htmlString);
    document.close();
}

export const saveToSessionStorage = (htmlString, json) => {
    const key = `LHSYS_${json.pageContext}_${json.langcode}_${json.path}`;

    window.sessionStorage.setItem(key, htmlString);
};

export const checkSessionStorage = json => {
    const key = `LHSYS_${json.pageContext}_${json.langcode}_${json.path}`;

    return window.sessionStorage.getItem(key);
};

export const showPageHtml = () => {
    const [bodyContent] = document.getElementsByClassName('isPreviewPasswordPage');
    const [enterPasswordContent] = document.getElementsByClassName('isEnterPasswordPageContent');

    bodyContent.classList.add('visible');
    enterPasswordContent.classList.add('visible');

    window?.dispatchEvent(new Event('resize'));
    window?.scrollTo(0, 0);
};
